import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconGithub = ({
  title = "Github",
  viewBoxWidth = 32,
  viewBoxHeight = 32,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M16 32a16 16 0 110-32 16 16 0 010 32zm2.8-14.5a1 1 0 00-.8.5c-.3.3-.4.6-.4 1 0 .5.1.9.4 1.2.2.3.5.4.8.4.3 0 .5-.1.8-.4.2-.3.3-.7.3-1.1 0-.5-.1-.8-.3-1.1-.3-.3-.5-.5-.8-.5zm4-4v-1.3c-.1-.9-.3-1.7-.6-2.4h-.5l-1.4.6-2.1 1.2c-.5-.2-1.2-.3-2.2-.3-1 0-1.7.1-2.2.3a9.4 9.4 0 00-4-1.8c-.3.7-.5 1.5-.5 2.4v1.3c-.9 1-1.3 2-1.3 3.4 0 .8.1 1.6.3 2.2l.7 1.7c.3.4.7.8 1.2 1a5.6 5.6 0 002.4 1.1 10.4 10.4 0 002.5.2 20.4 20.4 0 005.5-.5 5.7 5.7 0 002.4-1.8l.7-1.7A8 8 0 0024 17c0-1.3-.4-2.4-1.3-3.4zM16 22.3c-2 0-3.4-.2-4.4-.7-1-.4-1.4-1.3-1.4-2.8 0-.8.3-1.5.9-2 .2-.2.5-.4 1-.5l1-.1a45.2 45.2 0 013 .1h3.7c.4 0 .8.2 1.1.5.7.5 1 1.2 1 2 0 1.5-.5 2.4-1.5 2.8-1 .5-2.4.7-4.4.7zm-2.7-4.8a1 1 0 00-.9.5c-.2.3-.3.6-.3 1 0 .5.1.9.3 1.2.3.3.5.4.9.4.3 0 .5-.1.7-.4.3-.3.4-.7.4-1.1 0-.5-.1-.8-.4-1.1-.2-.3-.4-.5-.7-.5z"
      fill="#242A2D"
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconGithub
